import {
  Module,
  VuexModule,
  getModule,
  Mutation,
} from "vuex-module-decorators";

const name = "toolbar";

import store from "@/store";

if (store.state[name]) {
  store.unregisterModule(name);
}

@Module({ dynamic: true, namespaced: true, store, name: name })
export class ToolbarContentVuexModule extends VuexModule {
  rawTitle: string | undefined = undefined;
  i18nResource: string | undefined = undefined;
  showClientUserContextFallback = true;
  toolbarActionsResolved = false;

  get toolbarTitleValues() {
    return {
      rawTitle: this.rawTitle,
      i18nResource: this.i18nResource,
    };
  }

  get toolbarFallbackValues() {
    return {
      showClientUserContextFallback: this.showClientUserContextFallback,
      toolbarActionsResolved: this.toolbarActionsResolved,
    };
  }

  @Mutation
  setToolbarTitle(title: string) {
    this.rawTitle = title;
    this.i18nResource = undefined;
  }

  @Mutation
  setI18nResource(resource: string) {
    this.rawTitle = undefined;
    this.i18nResource = resource;
  }

  @Mutation
  clear() {
    this.rawTitle = undefined;
    this.i18nResource = undefined;
    this.showClientUserContextFallback = true;
    this.toolbarActionsResolved = false;
  }

  @Mutation
  setToolbarActionsResolved(isResolved: boolean) {
    this.toolbarActionsResolved = isResolved;
  }

  @Mutation
  resetToolbarActionsState() {
    this.toolbarActionsResolved = false;
  }
}

export const ToolbarContentModule = getModule(ToolbarContentVuexModule);
